<div class="height-100">
  <router-outlet></router-outlet>
</div>
